import { render } from "./callCenterView.vue?vue&type=template&id=fc9b6da0&scoped=true"
import script from "./callCenterView.vue?vue&type=script&lang=js"
export * from "./callCenterView.vue?vue&type=script&lang=js"

import "./callCenterView.vue?vue&type=style&index=0&id=fc9b6da0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc9b6da0"]])

export default __exports__